var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown-menu',_vm._b({model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},'dropdown-menu',{..._vm.$props, ..._vm.$attrs},false),[_c('button',{attrs:{"id":_vm.identifier,"hidden":""}}),_vm._t("dropdownbutton"),_c('div',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_vm._t("dropdownbody")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }